// 引入共用資料
import comm_data from '../comm_data';
import comm_imgs from '../comm_imgs';




export class AdjustBedShape{
    /**
     * 平躺模式/人體校正值
     *
     * @param {number} _x Sensor參數值
     * @returns {number} _x 校正後的Sensor參數值
     */
    constructor(_sensorValue, _bodyWeight = 100){
        this.weight = parseInt(_bodyWeight)
        this.value = parseInt(_sensorValue)
    }
    WeightTrans() {
        return (100-this.weight)*15
    }
    centralizeValue() {
        // 5 6 7 8 11 12
        if ((this.value <= 5) || (Number.isNaN(this.value))) return 5
        if (this.value < 2000) { return (this.value + this.WeightTrans(this.weight) - 5) * 0.125 + 2750 }
        else if (this.value < 2400) { return (this.value + this.WeightTrans(this.weight) - 2400) * 0.15 + 3000 }
        else if (this.value < 2800) { return (this.value + this.WeightTrans(this.weight) - 2400) * 0.15 + 3250 }
        else if (this.value < 3200) { return (this.value + this.WeightTrans(this.weight) - 2400) * 0.15 + 3500 }
        else if (this.value < 3600) { return (this.value + this.WeightTrans(this.weight) - 2400) * 0.15 + 3750 }
        else if (this.value < 4000) { return (this.value + this.WeightTrans(this.weight) - 2400) * 0.15 + 4000 }
        else { return this.value }
    } // END addWeight
    addWeight() {
        // 5 6 7 8 11 12
        if ((this.value <= 5) || (Number.isNaN(this.value))) return 5
        if (this.value < 2000) { return (this.value - 5) * 0.125 + 2750 }
        else if (this.value < 2400) { return (this.value - 2400) * 0.15 + 3000 }
        else if (this.value < 2800) { return (this.value - 2400) * 0.15 + 3250 }
        else if (this.value < 3200) { return (this.value - 2400) * 0.15 + 3500 }
        else if (this.value < 3600) { return (this.value - 2400) * 0.15 + 3750 }
        else if (this.value < 4000) { return (this.value - 2400) * 0.15 + 4000 }
        else { return this.value }
    } // END addWeight
    minusWeight() {
        // 1 2 3 4 9 10
        if ((this.value <= 5) || (Number.isNaN(this.value))) return 5
        if (this.value < 2000) { return 1000 - (this.value - 5) * 0.125 }
        else if (this.value < 2400) { return 1500 - (this.value - 2500) * 0.125 }
        else if (this.value < 2800) { return 2000 - (this.value - 2500) * 0.125 }
        else if (this.value < 3200) { return 2500 - (this.value - 2500) * 0.125 }
        else if (this.value < 3600) { return 3500 - (this.value - 2500) * 0.125 }
        else if (this.value < 4000) { return 4000 - (this.value - 2500) * 0.125 }
        else { return this.value }
        
    } // END minusWeight
        
} // END toAdjustMath
/**
 * Bed相關處理類別
 */
export default class BedHandler {
    /**
     * 讀取Bed各種角度值，來回傳對應圖片。
     *
     * @param {object} object Date共用參數
     * @param {String|number} object.foot_angle 腳升降
     * @param {String|number} object.back_angle 背升降
     * @param {String|number} object.turn_position 左右轉
     * @returns {{img: string, msg: string}} { img: 指定顯示的圖片, msg: 狀態訊息 }
     */
    static getStatus({
        foot_angle = 0,
        back_angle = 0,
        turn_position = 0,
        turn_angle = 0
    } = {}) {

        let exportIMG = comm_imgs["NORISE_0"];
        let exportMSG = "norise";
        const footAngle = Number(foot_angle);
        const backAngle = Number(back_angle);
        const turnPosition = Number(turn_position);
        const turnAngle = Number(turn_angle);

        /* 確定是否為無效整數值 */
        if (
            Number.isNaN(footAngle) ||
            Number.isNaN(backAngle) ||
            Number.isNaN(turnPosition) ||
            Number.isNaN(turnAngle)
        ) {
            return {
                img: exportIMG,
                msg: exportMSG
            }
        }

        /* 腳、背同時抬起 */
        if (footAngle > 0 && backAngle > 0) {
            exportMSG = "bfrise";
            exportIMG = comm_imgs["BFRISE"];
        } else if (footAngle > 0 || backAngle > 0) {
            /* 只有 腳 或 背 抬起 */

            // 只有腳抬起
            if (footAngle > 0 && footAngle < 15) { exportIMG = comm_imgs["FOOTRISE_15"]; exportMSG = "footrise_15"; }
            else if (footAngle >= 15 && footAngle < 30) { exportIMG = comm_imgs["FOOTRISE_30"]; exportMSG = "footrise_30"; }
            else if (footAngle >= 30 && footAngle < 45) { exportIMG = comm_imgs["FOOTRISE_45"]; exportMSG = "footrise_45"; }
            else if (footAngle >= 45 && footAngle < 60) { exportIMG = comm_imgs["FOOTRISE_60"]; exportMSG = "footrise_60"; }
            else if (footAngle >= 60) { exportIMG = comm_imgs["FOOTRISE_75"]; exportMSG = "footrise_75"; }


            // 只有背抬起
            if (backAngle > 0 && backAngle < 15) { exportIMG = comm_imgs["BACKRISE_15"]; exportMSG = "backrise_15"; }
            else if (backAngle >= 15 && backAngle < 30) { exportIMG = comm_imgs["BACKRISE_30"]; exportMSG = "backrise_30"; }
            else if (backAngle >= 30 && backAngle < 45) { exportIMG = comm_imgs["BACKRISE_45"]; exportMSG = "backrise_45"; }
            else if (backAngle >= 45 && backAngle < 60) { exportIMG = comm_imgs["BACKRISE_60"]; exportMSG = "backrise_60"; }
            else if (backAngle >= 60) { exportIMG = comm_imgs["BACKRISE_75"]; exportMSG = "backrise_75"; }
        } else {
            /* 轉身 _P.S. 背、腳皆為0才會發生_ */
            // 左翻
            if (turnPosition === 0 && turnAngle > 0) {
                exportIMG = comm_imgs["TURNOVER_LEFTV2"];
                exportMSG = "turnover_leftv2";
            }
            // 右翻
            if (turnPosition === 1 && turnAngle > 0) {
                exportIMG = comm_imgs["TURNOVER_RIGHTV2"];
                exportMSG = "turnover_rightv2";
            }
        }

        return {
            img: exportIMG,
            msg: exportMSG
        }
    }


    /**
     * 處理 bed 時間格式
     *
     * @param {string|number}  _x 時間值 number: 針對秒數做時分秒轉換 string: 針對完整日期格式 _P.S. "2022-05-23T14:01:36.000000"_
     * @returns {string} _x 格式後時間值 _P.S. "14:01:36"_
     */
    static toHandleTime(_x = "") {
        const type = typeof _x;
        switch (type) {
            case 'string':
                if (_x.length !== 0) {
                    const regex = /(?<=T).*(?=\.)/m;
                    const str = String(_x);
                    return regex.exec(str)[0];
                } else {
                    return "00:00:00"
                }
            case 'number':
                /* 處理秒數 */
                const h = String(Math.floor(_x / 3600));
                const m = String(Math.floor((_x - h * 3600) / 60));
                const s = String(Math.floor((_x - h * 3600) % 60));
                const fmt_h = h.length === 1 ? ("0" + h) : h;
                const fmt_m = m.length === 1 ? ("0" + m) : m;
                const fmt_s = s.length === 1 ? ("0" + s) : s;
                return fmt_h + ":" + fmt_m + ":" + fmt_s;
            default:
                return "00:00:00"
        }

    }
}
